import { SContainer, SProgress } from './styled';

type LoaderProps = {
  isSemiTransparent?: boolean;
  size?: number;
  zIndex?: number;
};

export const Loader = ({ isSemiTransparent = false, size = 24, zIndex }: LoaderProps) => (
  <SContainer
    sx={(theme) => ({
      opacity: isSemiTransparent ? 0.7 : 1,
      zIndex: zIndex ?? theme.zIndex.loader,
    })}
  >
    <SProgress size={size} />
  </SContainer>
);
